import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

/**
 *  LICENC AKTIVÁLÁS (ügyfél-admin) – az intézmény a SAJÁT licenc-kulcsát adja meg itt.
 *  A kulcs intézményhez kötve tárolódik, a backend azonnal lekéri a licencszerverről (aláírás-ellenőrzéssel),
 *  és az állapot megmutatja a licencelt modulokat, a korlátokat (hány cég, hány felhasználó) és a lejáratot.
 *  Al-felhasználók NEM aktiválnak külön – a cég/intézmény licence takarja őket.
 */
@Component({
  selector: 'app-admin-licenc',
  templateUrl: './licenc.component.html',
})
export class LicencComponent implements OnInit {
  loading = false;
  mentes = false;
  kulcs = '';
  allapot: any = null;

  constructor(private data: DataService, private http: HttpClient) {}

  ngOnInit() {
    this.betolt();
  }

  betolt() {
    this.loading = true;
    this.http.get<any>('/api/licenc-allapot').subscribe({
      next: (r) => { this.allapot = r; this.loading = false; },
      error: (e) => {
        console.error('Licenc-állapot betöltési hiba:', e);
        this.loading = false;
        this.data.sendToast('Nem sikerült betölteni a licenc állapotát.', 'error');
      },
    });
  }

  aktival() {
    const k = (this.kulcs || '').trim();
    if (!k) { this.data.sendToast('Add meg a licenc-kulcsot.', 'error'); return; }
    this.mentes = true;
    this.http.post<any>('/api/licenc-allapot/kulcs', { kulcs: k }).subscribe({
      next: (r) => {
        this.mentes = false;
        this.allapot = r?.allapot || this.allapot;
        if (r?.aktivalva) {
          this.kulcs = '';
          this.data.sendToast('A licenc aktiválva.', 'success');
        } else {
          this.data.sendToast(r?.uzenet || 'A kulcs elmentve, de a szerver nem adott érvényes licencet.', 'warning');
        }
      },
      error: (e) => {
        this.mentes = false;
        this.data.sendToast(e?.error?.error || 'A licenc-aktiválás nem sikerült.', 'error');
      },
    });
  }

  get licenc() { return this.allapot?.licenc || null; }
  get modulok(): string[] { return Array.isArray(this.licenc?.modulok) ? this.licenc.modulok : []; }

  korlatSzoveg(kulcs: string): string {
    const k = this.licenc?.korlatok;
    const v = k ? k[kulcs] : null;
    return v == null ? 'korlátlan' : String(v);
  }

  get statuszSzin(): string {
    if (!this.allapot?.aktiv) return 'medium';
    if (this.allapot?.elavult) return 'danger';
    if (!this.licenc) return 'warning';
    if (this.licenc.ervenyes === false) return 'danger';
    return 'success';
  }

  get statuszSzoveg(): string {
    if (!this.allapot?.aktiv) return 'Nincs aktiválva (nincs kulcs)';
    if (!this.licenc) return 'Kulcs megadva – várakozás a szerverre';
    if (this.allapot?.elavult) return 'Elavult (a szerver régóta nem elérhető)';
    if (this.licenc.statusz === 'lejart') return 'Lejárt';
    if (this.licenc.statusz === 'felfuggesztve') return 'Felfüggesztve';
    if (this.licenc.ervenyes) return 'Érvényes';
    return 'Érvénytelen';
  }
}
